module.exports = __webpack_public_path__ + "img/T936.69fbd650.jpg";